import { Client } from '@stomp/stompjs';
import { JSEncrypt } from 'jsencrypt';
import moment from 'moment/moment';
import {
  casinoPL,
  cricketBookMakerPL,
  cricketFancyPL,
} from '../pages/game/profitLoss';
import store from '../redux/store';
import { CSVLink } from 'react-csv';
export const IS_PROD = process.env.REACT_APP_BASE_URL?.startsWith('https');
export const ASSETS_URL = 'http://casinoassets.betcricks.com/static/';
const FileSaver = require('file-saver');
const XLSX = require('xlsx');
const jsPDF = require('jspdf');

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_URL_BANKING = process.env.REACT_APP_BASE_URL_BANKING;
export const CRICKET_SERVICE_URL = process.env.REACT_APP_CRICKET_URL;
export const CRICKET_SERVICE_URL_SOCKET = process.env.REACT_APP_CRICKET_WS;
export const SOCCER_AND_TENNIS_SERVICE_URL = process.env.REACT_APP_SOCCER_TENNIS_URL;
export const SOCCER_AND_TENNIS_SERVICE_URL_SOCKET = process.env.REACT_APP_SOCCER_TENNIS_WS;
export const CASINO_SERVICE_URL = process.env.REACT_APP_CASINO_URL;
export const SCORECARD_API_URL = process.env.REACT_APP_SCORECARD_URL;
export const TUNNEL_API_URL = process.env.REACT_APP_TUNNEL_URL;
export const DIAMOND_CASINO_URL = process.env.REACT_APP_DIAMOND_CASINO_URL;
export const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQB0ZacT13Ok+3pX0lmuJ9dJ
F6atV7Vwv5gmgpvXiBVYKKM4sfGb2qg395uVcampRgLrM63KxElPkWaa90j10ol6
fnHneE3sGuNIrvUmSvtqgeSD8nS4GXdkDecD+HSB7OCOcr+oxsGZzXJdzN/5QyUd
DGpRTlm8T+yB6wa9sJPPgZJ/C650JF57WF+G3qSngqJZEtGrKLlZYL24AqVEg85d
gLsrawWpZUEGeYqhYsdSeoGqkAR6E8Ybw+YWEYCFyMLZi2Fe5MVwMARWQ5kzpKTx
0ur7DPsghrAem08DIAekAN97F1DS48Vs88T29C2716ylE27ICyiMLDw9DLXekhAD
AgMBAAE=
-----END PUBLIC KEY-----`;
export const buttonColors = '#c10930';
export const blueColor = '#007bff';
export const bgColor = '#eee';
export const secondaryColor = '#3C444B';
export const casinoBgColor = '#2E3439';
export const applyFancyFor = [
  'Over By Over',
  'Normal',
  'Ball By Ball',
  'meter',
  'fancy1',
  'oddeven',
];
export const sortByStringNumberInEnd = (a, b) => {
  const aNumber = parseInt(a);
  const bNumber = parseInt(b);
  if (aNumber && bNumber) {
    return aNumber - bNumber;
  } else if (aNumber) {
    return -1;
  } else if (bNumber) {
    return 1;
  } else {
    return a.localeCompare(b);
  }
};
var ENCRYPT = new JSEncrypt();
ENCRYPT.setPublicKey(PUBLIC_KEY);
export const Encrypt = (data) => ENCRYPT.encrypt(data);
export const getToken = () => {
  return store.getState().account.userData.token;
};
export const getCurrentDateTimeLocal = (
  prev = false,
  date_ = false,
  time = false
) => {
  let date = new Date(); // create a new Date object with the current date and time
  let year = date.getFullYear(); // get the four-digit year (e.g. 2023)
  let month = ('0' + (date.getMonth() + 1)).slice(-2); // get the month as a zero-padded two-digit string (e.g. "03")
  let day = ('0' + date.getDate()).slice(-2); // get the day of the month as a zero-padded two-digit string (e.g. "04")
  /*  let hour = ("0" + date.getHours()).slice(-2); // get the hour as a zero-padded two-digit string (e.g. "09")
  let minute = ("0" + date.getMinutes()).slice(-2); // get the minute as a zero-padded two-digit string (e.g. "05") */
  if (prev) {
    if (date_) {
      day = ('0' + (date.getDate() - date_)).slice(-2);
    } else {
      day = ('0' + (date.getDate() - 1)).slice(-2);
    }
  }
  let formattedDate = `${day}-${month}-${year}`; // concatenate the year, month, and day with hyphens as the separator
  return formattedDate;
};

export const convertEpochToDate = (epoch) => {
  return moment(epoch + 'Z').format('DD/MM/YYYY hh:mm A');
};
export function searchSubstringInArrayObjects(array, keys, searchString) {
  return array.filter((obj) => {
    return keys.some((key) => {
      if (!obj[key]) return false;
      return String(obj[key])
        .toLowerCase()
        .includes(searchString.toLowerCase());
    });
  });
}
export const getProfit = (selectedAmount, game, selectedEventForBet) => {
  let profit;
  let loss;
  let selectedAmount_ = selectedEventForBet.amount;
  if (selectedEventForBet.isBookmaker) {
    profit = cricketBookMakerPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).profit;
    loss = cricketBookMakerPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).loss;
  } else if (game == 'casino' || game == 'tennis' || game == 'soccer') {
    profit = casinoPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).profit;
    loss = casinoPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).loss;
  } else if (game == 'cricket' && selectedEventForBet.isFancy) {
    profit = cricketFancyPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).profit;
    loss = cricketFancyPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).loss;
  } else {
    profit = casinoPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).profit;
    loss = casinoPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).loss;
  }
  return {
    profit: parseFloat(profit).toFixed(2),
    loss: parseFloat(loss).toFixed(2),
  };
};

const CASINO_ODDS_ACTION_MAP = {
  dragonTiger20: 'gameData/setDragonTiger20Odds',
  casinoMeter: 'gameData/setCasinoMeterOdds',
  teenPatti20: 'gameData/setTeenPatti20Odds',
  dragonTiger202: 'gameData/setDragonTiger202Odds',
  lucky7: 'gameData/setLucky7Odds',
  lucky7eu: 'gameData/setLucky7euOdds',
  casinoQueen: 'gameData/setCasinoQueenOdds',
  aaa: 'gameData/setAaaOdds',
  poker20: 'gameData/setPoker20Odds',
  dragonTigerOneDay: 'gameData/setDragonTigerOneDayOdds',
  teen: 'gameData/setTeenOdds',
  andarBahar20: 'gameData/setAndarBahar20Odds',
  abj: 'gameData/setAbjOdds',
  card32: 'gameData/setCard32Odds',
  dragonTigerLion: 'gameData/setDragonTigerLionOdds',
  teen8: 'gameData/setTeen8Odds',
  teen9: 'gameData/setTeen9Odds',
  poker9: 'gameData/setPoker9Odds',
  card32eu: 'gameData/setCard32euOdds',
  baccarat2: 'gameData/setBaccarat20Odds',
  race20: 'gameData/setRace20Odds',
  worli2: 'gameData/setWorli2Odds',
  bollywoodTable: 'gameData/setBollywoodTableOdds',
  casinoWar: 'gameData/setCasinoWarOdds',
  baccarat: 'gameData/setBaccaratOdds',
  cmatch20: 'gameData/setCmatch20Odds',
  worli: 'gameData/setWorliOdds',
  superOver: 'gameData/setSuperOverOdds',
  cricketV3: 'gameData/setCricketv3Odds',
};

// Staleness threshold — if no message in 8s, force reconnect.
const SOCKET_STALE_THRESHOLD = 8000;
const SOCKET_WATCHDOG_INTERVAL = 5000;

export const createSocket = (
  id,
  dispatch,
  game = 'dragonTiger20',
  port,
  service
) => {
  let stompURL;
  if (id === 'casino') {
    const casinoBase = IS_PROD ? CASINO_SERVICE_URL : `${CASINO_SERVICE_URL}:${port}`;
    stompURL = casinoBase.replace('https://', 'wss://').replace('http://', 'ws://') + `/${service}/websocket`;
  } else {
    stompURL =
      id === 'cricket'
        ? CRICKET_SERVICE_URL_SOCKET
        : SOCCER_AND_TENNIS_SERVICE_URL_SOCKET;
  }

  dispatch({ type: 'accountData/setLoading', payload: true });

  let lastMsgTime = 0;

  const client = new Client({
    brokerURL: stompURL,
    reconnectDelay: 3000,
    heartbeatIncoming: 15000,
    heartbeatOutgoing: 15000,
    debug: () => null,
    onConnect: () => {
      lastMsgTime = Date.now();
      dispatch({ type: 'accountData/setLoading', payload: false });

      // Subscribe to liveMatches for sport connections (not casino)
      if (id !== 'casino') {
        client.subscribe('/live/liveMatches', (message) => {
          try {
            lastMsgTime = Date.now();
            const data = JSON.parse(message.body);
            if (data && typeof data === 'object') {
              if (id === 'cricket') {
                dispatch({ type: 'gameData/setCricketInPlayGames', payload: data });
              }
              if (id === 'soccer' || id === 'tennis') {
                dispatch({ type: 'gameData/setSoccerInPlayGames', payload: data.soccerAllMatchesResponseDTOS });
                dispatch({ type: 'gameData/setTennisInPlayGames', payload: data.tennisAllMatchesResponseDTOS });
              }
            }
          } catch (e) { console.warn(`[WS] ${id} liveMatches parse error:`, e.message); }
        });
      }

      // Subscribe to liveOdds
      let url = '';
      if (id === 'cricket') url = '/live/liveOdds';
      if (id === 'soccer') url = '/live/soccer/liveOdds';
      if (id === 'tennis') url = '/live/tennis/liveOdds';
      if (id === 'casino') url = `/live/${game}`;

      let pendingOdds = null;
      let rafId = null;

      const flushOdds = () => {
        rafId = null;
        if (!pendingOdds) return;
        const data = pendingOdds;
        pendingOdds = null;
        if (id === 'cricket') {
          dispatch({ type: 'gameData/setCricketOdds', payload: data });
        } else if (id === 'soccer') {
          dispatch({ type: 'gameData/setSoccerOdds', payload: data });
        } else if (id === 'tennis') {
          dispatch({ type: 'gameData/setTennisOdds', payload: data });
        } else if (id === 'casino') {
          const actionType = CASINO_ODDS_ACTION_MAP[game];
          if (actionType) {
            dispatch({ type: actionType, payload: data });
          }
          dispatch({ type: 'accountData/setLoading', payload: false });
        }
      };

      client.subscribe(url, (message) => {
        try {
          lastMsgTime = Date.now();
          const data = JSON.parse(message.body);
          if (data && typeof data === 'object') {
            pendingOdds = data;
            if (!rafId) {
              rafId = requestAnimationFrame(flushOdds);
            }
          }
        } catch (e) { console.warn(`[WS] ${id} liveOdds parse error:`, e.message); }
      });
    },
    onStompError: (frame) => {
      console.warn(`[WS] ${id} STOMP error:`, frame.headers?.message || '');
      dispatch({ type: 'accountData/setLoading', payload: false });
    },
    onWebSocketClose: () => {
      console.warn(`[WS] ${id} connection closed, will auto-reconnect`);
    },
  });

  client.activate();

  // Staleness watchdog — if no message in 8s, force deactivate + reactivate.
  const watchdog = setInterval(() => {
    if (lastMsgTime > 0 && Date.now() - lastMsgTime > SOCKET_STALE_THRESHOLD) {
      console.warn(
        `[WS] ${id} stale for ${Math.round((Date.now() - lastMsgTime) / 1000)}s — forcing reconnect`
      );
      lastMsgTime = 0;
      try { client.deactivate(); } catch (e) {}
      setTimeout(() => {
        try { client.activate(); } catch (e) {}
      }, 500);
    }
  }, SOCKET_WATCHDOG_INTERVAL);

  // Attach watchdog to client so caller can clean it up
  client._stalenessWatchdog = watchdog;

  return client;
};
export const updateReduxToken = (token) => (dispatch) => {
  dispatch({
    type: 'accountData/setToken',
    payload: token,
  });
};

export const exportToCsvReactCsv = (csvData, fileName) => {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';
  const data = csvData;
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data1 = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data1, fileName + fileExtension);
};

export const exportToPdf = (component) => {
  const doc = new jsPDF.jsPDF();
  doc.html(document.querySelector('#' + component), {
    callback: function (pdf) {
      pdf.save(component + '.pdf');
    },
  });
};

export const pokerGameList = [
  {
    name: 'super over',
    url: 'superover.jpg',
    path: 'superOver',
  },
  {
    name: 'race 20-20',
    url: 'race20.png',
    path: 'race20',
  },
  {
    name: 'casino queen',
    url: 'queen.jpg',
    path: 'casinoQueen',
  },
  {
    name: '5five cricket',
    url: '5five cricket.jpg',
    path: 'cricketV3',
  },
  {
    name: 'andar-bahar2',
    url: 'andar-bahar2.jpg',
    path: 'abj',
  },
  {
    name: '20-20 dragon tiger 2',
    url: '20-20 dragon tiger 2.jpg',
    path: 'dragonTiger202',
  },
  {
    name: 'baccarat2',
    url: 'baccarat2.jpg',
    path: 'baccarat2',
  },
  {
    name: 'baccarat',
    url: 'baccarat.png',
    path: 'baccarat',
  },
  {
    name: 'lucky7-b',
    url: 'lucky7-b.jpg',
    path: 'lucky7eu',
  },
  {
    name: 'casino queen',
    url: 'queen.jpg',
    path: 'casinoQueen',
  },
  {
    name: '20-20 cricket match',
    url: '20-20 cricket match.jpg',
    path: 'cmatch20',
  },
  {
    name: 'casino meter',
    url: 'casino meter.jpg',
    path: '',
  },
  {
    name: 'casino war',
    url: 'casino war.jpg',
    path: 'casinoWar',
  },
  {
    name: '20-20 dtl',
    url: '20-20 dtl.jpg',
    path: 'dragonTigerLion',
  },
  {
    name: '20-20 teenpatti',
    url: 'test teenpatti.jpg',
    path: 'teenPatti20',
  },
  {
    name: 'test teenpatti',
    url: 'test teenpatti.jpg',
    path: 'teen9',
  },
  {
    name: 'open teenpatti',
    url: 'open teenpatti.jpg',
    path: 'teen8',
  },
  {
    name: '1 day teenpatti',
    url: '1 day teenpatti.jpg',
    path: 'teen',
  },
  {
    name: '6 player poker',
    url: '6 player poker.jpg',
    path: 'poker9',
  },
  // {
  //   name: "1 day poker",
  //   url: "1 day poker.jpg",
  //   path: "poker",
  // },
  {
    name: '20-20 poker',
    url: '20-20 poker.jpg',
    path: 'poker20',
  },
  {
    name: 'andar-bahar',
    url: 'andar-bahar.jpg',
    path: 'andarBahar20',
  },
  // {
  //   name: "worli matka",
  //   url: "worli matka.jpg",
  //   path: "worli",
  // },
  {
    name: 'instant worli',
    url: 'instant worli.jpg',
    path: 'worli2',
  },
  // {
  //   name: "3 cards Judgement",
  //   url: "3 cards Judgement.jpg",
  //   path: "3cardsjudgement",
  // },
  {
    name: '32cardsA',
    url: '32cardsA.jpg',
    path: 'card32',
  },
  {
    name: '32cardsB',
    url: '32cardsB.jpg',
    path: 'card32eu',
  },
  {
    name: 'amar akbar anthony',
    url: 'amar akbar anthony.jpg',
    path: 'aaa',
  },
  {
    name: 'bollywood-casino',
    url: 'bollywood-casino.jpg',
    path: 'bollywoodTable',
  },
  {
    name: '20-20 dragon tiger',
    url: '20-20 dragon tiger.jpg',
    path: 'dragonTiger20',
  },
  {
    name: '1 day dragon tiger',
    url: '1 day dragon tiger.jpg',
    path: 'dragonTigerOneDay',
  },
  {
    name: 'lottery',
    url: 'lottery.jpg',
    path: '',
  },
  {
    name: 'lucky7-a',
    url: 'lucky7-a.jpg',
    path: 'lucky7',
  },
];
export const sidebarCasinoList = [
  {
    name: 'race 20-20',
    url: 'race20.png',
    path: 'race20',
  },
  {
    name: 'casino queen',
    url: 'queen.jpg',
    path: 'casinoQueen',
  },

  {
    name: 'Dragon Tiger',
    url: '20-20 dragon tiger 2.jpg',
    path: '?name=dragon-tiger',
  },
  {
    name: 'Sports Casino',
    url: '',
    path: '?name=sports-casino',
  },
  {
    name: 'Andar Bahar',
    url: '',
    path: '?name=andar-bahar',
  },

  {
    name: 'Bollywood Casino',
    url: 'casino war.jpg',
    path: '?name=bollywood',
  },
  {
    name: 'Casino War',
    url: 'casino war.jpg',
    path: 'casinoWar',
  },

  // {
  //   name: "worli matka",
  //   url: "worli matka.jpg",
  //   path: "worli",
  // },
  {
    name: 'Worli',
    url: 'instant worli.jpg',
    path: 'worli2',
  },
  {
    name: 'lottery',
    url: 'lottery.jpg',
    path: '',
  },
];
